var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'overflow-hidden': _vm.isScrollHidden },attrs:{"id":"app","keydown":_vm.handleKeyup}},[_c('ConfigProvider',{attrs:{"locale":_vm.ja_JP}},[_c('router-view')],1)],1),(_vm.loading)?_c('div',{staticClass:"app-spinner"},[_c('a-spin',{attrs:{"spinning":_vm.loading,"size":"large"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }